import { Card, Typography } from "antd";
import RewardListTab from "src/components/reward/tabs/RewardListTab";

export default function RewardManagePage() {
  return (
    <div style={{ padding: 24 }}>
      <Card
        styles={{ body: { padding: 20 } }}
        style={{ borderRadius: 12, border: "1px solid #e0e0e0" }}
      >
        <Typography.Title level={4} style={{ fontWeight: 900, marginBottom: 16 }}>
          리워드 관리
        </Typography.Title>

        <RewardListTab />
      </Card>
    </div>
  );
}
